import { BRAZIL_DEALER_LOCATION } from "../constants";

const invoiceTypesWithNfeAttachment = ["Order Invoice", "Debit Memo"];

export const invoiceTypeHasNfeAttachment = (
  invoiceType: string = "",
  dealerLocation: string = ""
): boolean =>
  dealerLocation === BRAZIL_DEALER_LOCATION &&
  invoiceTypesWithNfeAttachment.includes(invoiceType);
